// extracted by mini-css-extract-plugin
module.exports =  {"round-progress":"round-progress--NJ7v6","roundProgress":"round-progress--NJ7v6","light":"light--UjTUk","loader":"loader--Lcwyw"};